export default "__VITE_ASSET__hNkPAJaF__"